import { Component, OnInit, ViewChild, ViewContainerRef, Type, ComponentRef, ChangeDetectionStrategy } from '@angular/core';
import { Modal } from '../../modal.model';

declare var UIkit: any;

@Component({
    selector: 'app-modal-container',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalContainerComponent {

    @ViewChild('modalContainer', { read: ViewContainerRef }) 
    private modalContainer: ViewContainerRef;
    createModal<T extends Modal>(component: Type<T>): ComponentRef<T> {
        UIkit.modal('#modal-container').show();

        this.modalContainer.clear();

        return this.modalContainer.createComponent(component);
    }

}
